
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './home.css'
import CaroNextSvg from '../../svgs/home/CaroNextSvg.js'
import Sec4ArrowSvg from '../../svgs/home/Sec4ArrowSvg.js'
import InViewComponent from '../../screens/components/InView.js';
import { useRef, useState, useEffect } from 'react';

import { useLang } from '../../hook/UseLang.js';
import { useNavigate } from 'react-router-dom';
import { getNewsDetail } from '../../services/news.js';
import CONTENT from '../../contents/home.js'
const caroData = [
  {
      homeImg:'./images/home/sec5_1.jpg',
      img:'n0',
      date:'2015.05.05',
      title:'Location Information'
  },
  {
      homeImg:'./images/home/sec5_2.jpg',
      img:'n1',
      date:'2015.05.15',
      title:'Enjoy the summer! Limited to 3 sets of dinner set menus per day-Since June 1st-'
  },
  {
      homeImg:'./images/home/sec5_3.jpg',
      img:'n2',
      date:'2015.05.15',
      title:'【Limited】Collaboration event is currently being held'
  },
  {
      homeImg:'./images/home/sec5_4.jpg',
      img:'n3',
      date:'2015.05.25',
      title:'Notice of closure due to major renovations'
  },
]
function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className='custom-arrow next-arrow-2 slick-arrow'
      style={{ ...style, display: "block" }}
      onClick={onClick}>
          <CaroNextSvg />
      </div>
    );
  }
  
function SamplePrevArrow(props) {
const { className, style, onClick } = props;
return (
    <div className='custom-arrow prev-arrow-2 slick-arrow'
    style={{ ...style, display: "block" }}
    onClick={onClick}>
        <CaroNextSvg isLeft={true}/>
    </div>
);
}
//
export default function Sec3Slider() {
  const navigate = useNavigate()
  const [lang, setLang] = useLang()
  const [news, setNews] = useState([])
  useEffect(() =>{ 
    const getData = async () => {
        const filter = {
          status:'PUBLISHED'
        }
        const options = {
            limit:8,
            skip:0,
        }
        const newsRes = await getNewsDetail(filter, options)
        if(newsRes.errno)return;
        // console.log(newsRes)
        setNews(newsRes.result)
    }
    getData()
  },[])
  //
  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(news?.length,4),
    slidesToScroll: 1,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    vertical: false,
    responsive: [
      {
          breakpoint: 800,
          settings: {
              slidesToShow: 1,
          },
      },
  ],
  };
  function Card1 ({item, index}) {
    const textRef = useRef(null);
    return(
    <div onClick={() => navigate(`/news/${item._id}?lang=${lang}`, { state: {...item} })} className='relative px-[10px] overflow-hidden cursor-pointer min-h-[400px] flex flex-row items-center justify-center' style={{}}>
      <div className='flex flex-row-col w-full h-full overflow-hidden max-w-[500px]'>
        <div className='relative flex flex-col items-center justify-between h-full w-full'>
            <div className='relative w-full overflow-hidden ' style={{aspectRatio:13/9}}>
                {/* overlay */}
                <div className='absolute w-full h-full appear-cover-2 flex flex-col items-center justify-center' style={{zIndex:2}}>
                  <div className='flex flex-col items-center justify-center w-[70%] h-[90%]' style={{gap:24}}>
                    <div className='w-[118px] h-[118px] relative topleft-cutto-bottomright'>
                      <div className='w-full h-[1px] absolute top-[50%] bg-[#0FBAB5]'></div>
                      <div className='w-[1px] h-full absolute left-[50%] bg-[#0FBAB5]'></div>
                    </div>
                  </div>
                </div>
                <img src={item.previewImage} className='w-full h-full' style={{objectFit:'cover'}}></img>
            </div> 
            <div className='w-full h-full flex flex-col items-center justify-center max-w-[300px] my-[24px]' style={{flex:'1 0 auto'}}>
              <div className='text-d-12 text-[#0FBAB5]'>{item.date}</div>
              <div ref={textRef} className='text-center text-d-12 title_text'>{item[`name_${lang === 'sc' ? 'ch' : lang}`]}</div>
              <InViewComponent reffing={textRef} active='title_text_active' />
            </div>
        </div>
      </div>
    </div>
  )}

  const textRef = useRef(null);
  return (
    <div className="carousel-container static-next w-[100%]">
      <div ref={textRef} className='text-homesec-title absolute top-[-7%] w-full text-center playfair-display title_text' style={{letterSpacing:5}}>{CONTENT.sec5_0[lang]}</div>
      <InViewComponent reffing={textRef} active='title_text_active' />
      {news.length > 1 && <Slider {...settings} className='w-[100%]' >
        {news.map((obj,i) => (<Card1 item={obj} index={i}/>))}
      </Slider>}
      {news.length === 1 && <Card1 item={news[0]} index={0} />}
      {!news?.length && <div className='w-full h-[300px] flex flex-row items-center justify-center'>
        <span>{CONTENT.noNews[lang]}</span>
      </div>}
    </div>
  );
}